export default function FiChevronDownSvg() {
	return (
		<svg
			aria-hidden="true"
			role="presentation"
			stroke="currentColor"
			fill="none"
			strokeWidth="2"
			viewBox="0 0 24 24"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="w-[1em]"
			height="1em"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
		>
			<polyline points="6 9 12 15 18 9"></polyline>
		</svg>
	);
}
